import Award, { type AwardProps } from '@/components/Award/Award';
import classes from '@/components/Awards/Awards.module.scss';
import type { storyblokEditable } from '@storyblok/react/rsc';
import classNames from 'classnames';
import type { ReactNode } from 'react';

export type AwardsProps = {
  className?: string;
  'data-block-c'?: string;
  'data-block-uid'?: string;
} & (
  | {
      awards: AwardProps[];
      children?: never;
    }
  | {
      awards?: never;
      children: ReactNode;
    }
);

const Awards: React.FC<AwardsProps> = (props) => {
  let length = 0;

  if (!!props.awards) {
    length = props.awards.length;
  } else if (!!props.children && Array.isArray(props.children)) {
    length = props.children.length;
  }

  return (
    <div className={classNames(classes.awards, props.className)} data-awards={length} {...props}>
      {props.awards &&
        props.awards?.map((award: AwardProps, index: number) => {
          return <Award {...award} key={index} />;
        })}
      {props.children}
    </div>
  );
};
export default Awards;
